import { getCurrentApi } from './baseAPI';

export const engineRoleAPI = {
  getStatusDetailed: async () => {
    try {
      const api = await getCurrentApi();
      const response = await api.get('/engine-roles/status-detailed');
      return response;
    } catch (error) {
      console.error('GET /engine-roles/status-detailed error:', error);
      throw error;
    }
  },

  selectPrimary: async () => {
    try {
      const api = await getCurrentApi();
      const response = await api.post('/engine-roles/select-primary', {});
      return response;
    } catch (error) {
      console.error('POST /engine-roles/select-primary error:', error);
      throw error;
    }
  },

  setRole: async (endpoint, role) => {
    try {
      const api = await getCurrentApi();
      const response = await api.post('/engine-roles/set-role', {
        endpoint,
        role
      });
      return response;
    } catch (error) {
      console.error('POST /engine-roles/set-role error:', error);
      throw error;
    }
  },

  setMultipleRoles: async (roleAssignments) => {
    try {
      const api = await getCurrentApi();
      const response = await api.post('/engine-roles/set-multiple-roles', {
        roleAssignments
      });
      return response;
    } catch (error) {
      console.error('POST /engine-roles/set-multiple-roles error:', error);
      throw error;
    }
  },

  requestServiceInfo: async () => {
    try {
      const api = await getCurrentApi();
      const response = await api.post('/engine-roles/request-service-info', {});
      return response;
    } catch (error) {
      console.error('POST /engine-roles/request-service-info error:', error);
      throw error;
    }
  },

  getPrimaryInfo: async () => {
    try {
      const api = await getCurrentApi();
      const response = await api.get('/engine-roles/primary-info');
      return response;
    } catch (error) {
      console.error('GET /engine-roles/primary-info error:', error);
      throw error;
    }
  },

  stepDown: async (endpoint, reason) => {
    try {
      const api = await getCurrentApi();
      const response = await api.post('/engine-roles/step-down', {
        endpoint,
        reason
      });
      return response;
    } catch (error) {
      console.error('POST /engine-roles/step-down error:', error);
      throw error;
    }
  },

  getStepDownHistory: async (endpoint) => {
    try {
      const api = await getCurrentApi();
      const response = await api.get(`/engine-roles/step-down-history/${encodeURIComponent(endpoint)}`);
      return response;
    } catch (error) {
      console.error(`GET /engine-roles/step-down-history/${endpoint} error:`, error);
      throw error;
    }
  },

  getAllStepDownHistory: async () => {
    try {
      const api = await getCurrentApi();
      const response = await api.get('/engine-roles/step-down-history');
      return response;
    } catch (error) {
      console.error('GET /engine-roles/step-down-history error:', error);
      throw error;
    }
  },

  getStepDownStats: async () => {
    try {
      const api = await getCurrentApi();
      const response = await api.get('/engine-roles/step-down-stats');
      return response;
    } catch (error) {
      console.error('GET /engine-roles/step-down-stats error:', error);
      throw error;
    }
  },

  getStatusWithStepdown: async () => {
    try {
      const api = await getCurrentApi();
      const response = await api.get('/engine-roles/status-with-stepdown');
      return response;
    } catch (error) {
      console.error('GET /engine-roles/status-with-stepdown error:', error);
      throw error;
    }
  },

  getServiceStatus: async () => {
    try {
      const api = await getCurrentApi();
      const response = await api.get('/engine-roles/service-status');
      return response;
    } catch (error) {
      console.error('GET /engine-roles/service-status error:', error);
      throw error;
    }
  }
};
